/**
 * 生成「所有权 使用权 改编权」价格
 */

import { useCallback, useMemo } from 'react'

type PriceObj = { price: any | null } | null

interface Params {
  buy?: PriceObj[] | null
  use?: PriceObj[] | null
  adapt?: PriceObj[] | null
}

export default function useProductPrice({
  buy = [],
  use = [],
  adapt = [],
}: Params) {
  const getPrice = useCallback(
    (priceList: PriceObj[] | PriceObj[] | PriceObj[] | null) => {
      const priceNumbers = priceList?.map(item => item?.price || 0) || []
      const max = Math.max(...priceNumbers)
      const min = Math.min(...priceNumbers)

      return {
        isSame: max === min,
        max,
        min,
      }
    },
    []
  )

  const buyPrice = useMemo(() => {
    return getPrice(buy)
  }, [buy])

  const usePrice = useMemo(() => {
    return getPrice(use)
  }, [use])

  const adaptPrice = useMemo(() => {
    return getPrice(adapt)
  }, [adapt])

  return {
    /** 所有权价格 */
    buyPrice,
    /** 使用权价格 */
    usePrice,
    /** 改编权价格 */
    adaptPrice,
  }
}
